// Client (tenant resolution, API transport)
export { ServiceLayerClient } from './client'
export type {
  ListScanOrdersResponse,
  ServiceLayerClientConfig,
  TenantConfig,
  TenantResolutionRequest,
  TenantResolutionResponse,
} from './client'
export type { BrandConfig } from './tenant'

// Auth (Supabase OAuth, cookie handoff, session management)
export type { ServiceLayerAuthConfig } from "./config";
export { resolveSiteOrigin, resolveApiBase } from "./config";
export { startLogin, handleAuthCallback } from "./authFlow";
export type { AuthCallbackResult } from "./authFlow";
export { normalizeRootHashToCallback } from "./hashShim";
export type { LocationLike } from "./hashShim";
export { apiFetch, apiJson, getSession, logout, withImpersonation, ServiceLayerApiError, isServiceLayerApiError } from "./apiHelpers";
export type { HttpMethod, ApiRequestInit, SessionShape } from "./apiHelpers";
// SL Supabase client accessors (storageKey `sb-clanda-sl`, autoRefreshToken:true).
// `getFreshServiceLayerAccessToken` triggers auto-refresh of a near/over-expiry
// token — the cure for silently sending a stale JWT
// (BUG-FE-SILENT-SESSION-JWT-DEGRADATION-2026-05-31).
export { getSupabaseClient, getFreshServiceLayerAccessToken } from "./supabaseClient";

import { startLogin as _startLogin, handleAuthCallback as _handleAuthCallback } from "./authFlow";
import { getSession as _getSession, logout as _logout } from "./apiHelpers";
import type { ServiceLayerAuthConfig } from "./config";

export interface ServiceLayerAuthClient {
  startLogin: (nextOverride?: string) => Promise<void>;
  handleAuthCallback: () => Promise<import("./authFlow").AuthCallbackResult>;
  getSession: () => Promise<import("./apiHelpers").SessionShape>;
  logout: () => Promise<void>;
}

/**
 * Factory that wires a config into a simple auth client object which can be
 * consumed from any SPA (React, Vue, etc.).
 */
export function createServiceLayerAuthClient(
  config: ServiceLayerAuthConfig
): ServiceLayerAuthClient {
  return {
    startLogin: (nextOverride?: string) =>
      _startLogin(config, nextOverride ? { nextPath: nextOverride } : {}),
    handleAuthCallback: () => _handleAuthCallback(config),
    getSession: () => _getSession(config),
    logout: () => _logout(config)
  };
}
